{
  "_meta": {
    "_comment": "Phase 6 Wave 3 Tasks 07+08+09+10 — products namespace FR (placeholder, falls back to EN). vg-binding: PLAN:task-07 / PLAN:task-08 / PLAN:task-09 / PLAN:task-10 / P6.D-15..24 / P6.D-34 / P6.D-38 / P6.D-39 / P6.D-43..50 / P6.D-51..58 / P6.D-139 / P6.D-148",
    "locale": "fr",
    "completeness": "placeholder"
  },
  "editor": {
    "unsavedGuard": {
      "title": "Quitter sans enregistrer ?",
      "body": "Vous avez des modifications non enregistrées. Quitter maintenant les supprimera.",
      "stay": "Rester",
      "leave": "Quitter et abandonner"
    },
    "title": {
      "placeholder": "Nom du produit…"
    },
    "tabs": {
      "general": "Général",
      "variants": "Variantes",
      "pricing": "Tarification",
      "media": "Images",
      "seo": "SEO"
    },
    "actions": {
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "cancel": "Annuler",
      "publish": "Publier",
      "delete": "Supprimer",
      "stay": "Rester",
      "leave": "Quitter",
      "unsavedTitle": "Modifications non enregistrées",
      "unsavedWarning": "Vous avez des modifications non enregistrées. Quitter les supprimera.",
      "unsavedMarker": "• non enregistré",
      "saved": "Produit enregistré",
      "saveFailed": "Échec de l’enregistrement",
      "noChanges": "Aucune modification à enregistrer"
    },
    "status": {
      "draft": "Brouillon",
      "active": "Actif",
      "archived": "Archivé"
    },
    "fields": {
      "name": "Nom du produit",
      "description": "Description",
      "descriptionPlaceholder": "Markdown supporté…",
      "category": "Catégorie",
      "categoryReadonly": "issu du blueprint",
      "tags": "Étiquettes",
      "tagsPlaceholder": "Ajouter une étiquette puis Entrée",
      "removeTag": "Supprimer {{tag}}"
    },
    "changelog": {
      "banner": "Blueprint v{{latest}} disponible. Version épinglée : v{{pinned}}.",
      "viewDiff": "Voir les changements"
    },
    "variant": {
      "intro": "Gérez les SKU, l'inventaire et les prix par variante.",
      "add": "Ajouter une variante",
      "remove": "Supprimer",
      "retire": "Retirer",
      "restrictedBadge": "Réservé",
      "restrictedTitle": "Ce SKU est réservé à un autre marchand : il ne peut être ni commandé ni modifié. Contactez votre gestionnaire de compte pour le changer.",
      "size": "Taille",
      "color": "Couleur",
      "sku": "SKU",
      "trackInventory": "Suivi stock",
      "trackOn": "Activé",
      "trackOff": "Désactivé",
      "inventory": "Inventaire",
      "priceOverride": "Prix (¢)",
      "actions": "Actions",
      "empty": "Aucune variante. Cliquez sur \"Ajouter\" pour créer la première."
    },
    "pricing": {
      "defaultsTitle": "Prix par défaut par palier",
      "defaultsHint": "Unité : centimes. Utilisé si aucun prix par boutique n'est défini.",
      "storesTitle": "Prix par boutique",
      "store": "Boutique",
      "empty": "Aucune boutique connectée.",
      "tier": {
        "titanium": "Titanium",
        "platinum": "Platinum",
        "diamond": "Diamond"
      }
    },
    "media": {
      "addByUrl": "Ajouter une image par URL",
      "add": "Ajouter",
      "empty": "Aucune image. Collez une URL pour en ajouter une.",
      "setPrimary": "Définir comme principale"
    },
    "seo": {
      "metaTitle": "Meta title",
      "metaDescription": "Meta description",
      "slug": "Slug URL",
      "slugHint": "Lettres minuscules, chiffres et tirets uniquement."
    },
    "publish": {
      "confirmTitle": "Publier le produit dans les boutiques ?",
      "confirmDesc": "Sélectionnez les boutiques où synchroniser ce produit.",
      "noStores": "Aucune boutique connectée."
    },
    "delete": {
      "confirmTitle": "Supprimer \"{{name}}\" ?",
      "confirmDesc": "Le produit sera retiré des listes publiques.",
      "softNote": "Suppression douce — récupérable pendant 30 jours."
    },
    "notFound": {
      "title": "Produit introuvable",
      "back": "Retour à Mes produits"
    }
  },
  "myProducts": {
    "title": "Mes produits",
    "subtitle": "Gérez votre catalogue et vos fiches en boutique.",
    "fromPrice": "À partir de {{price}}",
    "variantCount": "{{count}} variantes",
    "loadMore": "Charger plus",
    "loadingMore": "Chargement…",
    "cta": {
      "add": "Ajouter un produit",
      "bulkImport": "Import en masse",
      "settings": "Paramètres produits"
    },
    "tabs": {
      "label": "Filtre de statut",
      "all": "Tous",
      "active": "Actifs",
      "draft": "Brouillons",
      "archived": "Archivés",
      "inactive": "Inactif"
    },
    "filters": {
      "category": "Catégorie",
      "syncStatus": "Sync.",
      "store": "Boutique",
      "search": "Rechercher des produits…",
      "viewMode": "Mode d'affichage",
      "table": "Tableau",
      "grid": "Grille",
      "allStores": "Toutes les boutiques",
      "baseProduct": "Modèle de base",
      "allBaseProducts": "Tous les modèles de base",
      "searchBaseProduct": "Rechercher un modèle…",
      "loadingBaseProduct": "Chargement…",
      "noBaseProduct": "Aucun modèle de base",
      "refineSearch": "Affinez la recherche…"
    },
    "sort": {
      "createdDesc": "Plus récents",
      "createdAsc": "Plus anciens",
      "nameAsc": "Nom : A → Z",
      "nameDesc": "Nom : Z → A",
      "lastModifiedDesc": "Modifiés récemment",
      "syncStatus": "Statut de sync."
    },
    "sync": {
      "pending": "En attente",
      "syncing": "En cours",
      "synced": "Synchronisé",
      "failed": "Échec",
      "moreStores": "{{n}} boutiques de plus"
    },
    "actions": {
      "menu": "Actions",
      "view": "Voir",
      "edit": "Modifier",
      "duplicate": "Dupliquer",
      "publish": "Publier en boutique",
      "archive": "Archiver",
      "delete": "Supprimer",
      "unarchive": "Restaurer en brouillon"
    },
    "bulk": {
      "selected": "{{count}} sélectionné(s)",
      "publish": "Publication en lot",
      "archive": "Archivage en lot",
      "delete": "Suppression en lot",
      "clear": "Effacer la sélection",
      "confirmDeleteTitle": "Supprimer les produits sélectionnés ?",
      "confirmDeleteBody": "Vous êtes sur le point de supprimer {{count}} produit(s). Action irréversible.",
      "confirmDeleteConfirm": "Supprimer",
      "confirmDeleteCancel": "Annuler"
    },
    "empty": {
      "all": "Aucun produit pour l'instant.",
      "active": "Aucun produit actif pour l'instant.",
      "draft": "Aucun brouillon pour l'instant. En créer un ?",
      "archived": "Aucun produit archivé pour l'instant.",
      "cta": "Ajouter un produit",
      "titles": {
        "all": "Créez votre premier produit",
        "draft": "Aucun brouillon",
        "active": "Aucun produit actif",
        "archived": "Aucun produit archivé"
      },
      "bodies": {
        "all": "Choisissez un blueprint et personnalisez votre design — ou importez un CSV en masse.",
        "draft": "Enregistrez les produits en cours en brouillons. Parcourez le catalogue pour commencer.",
        "active": "Finalisez un brouillon et cliquez sur Publier pour synchroniser avec vos boutiques.",
        "archived": "Les produits archivés apparaissent ici. Vous pouvez les restaurer à tout moment."
      },
      "ctas": {
        "create": "Créer le premier produit",
        "browseCatalog": "Parcourir le catalogue",
        "publishDraft": "Publier le premier brouillon",
        "bulkImport": "Ou importer en masse"
      }
    },
    "bulkImport": {
      "subtitle": "Importez un CSV/XLSX pour créer plusieurs produits à la fois. Maximum {{n}} lignes par import.",
      "close": "Fermer",
      "dropHint": "Glissez-déposez un CSV/XLSX ici",
      "dropSubhint": "ou cliquez pour choisir un fichier",
      "title": {
        "upload": "Import de produits en masse",
        "preview": "Aperçu des données",
        "importing": "Import en cours…",
        "result": "Résultat de l'import"
      },
      "actions": {
        "back": "Retour",
        "import": "Importer les produits",
        "cancel": "Annuler",
        "importing": "Traitement…",
        "done": "Terminé"
      },
      "template": {
        "title": "Besoin d'un modèle ?",
        "subtitle": "Téléchargez le modèle CSV — colonnes requises + données d'exemple.",
        "download": "Télécharger le modèle"
      },
      "preview": {
        "summary": "{{rows}} lignes · {{cols}} colonnes",
        "ok": "Prêt à importer",
        "invalid": "Erreurs à corriger",
        "tooMany": "Le fichier dépasse la limite de {{n}} lignes par import. Découpez en lots plus petits.",
        "status": "Statut",
        "rowOk": "OK",
        "rowFail": "Erreur",
        "note": "10 premières lignes affichées en aperçu. Le reste est validé côté serveur."
      },
      "progress": {
        "label": "Import {{processed}}/{{total}} lignes…",
        "hint": "Veuillez garder cette fenêtre ouverte — l'import se termine en quelques secondes."
      },
      "result": {
        "allOk": "Import réussi",
        "partial": "Import partiel",
        "allFailed": "Import échoué",
        "summary": "{{succeeded}}/{{total}} lignes réussies, {{failed}} erreurs.",
        "errorsHeading": "Certaines lignes ont échoué",
        "downloadErrors": "Télécharger le rapport d'erreurs",
        "rowLabel": "Ligne {{index}}"
      },
      "parseError": "Impossible de lire le fichier. Veuillez réessayer.",
      "validation": {
        "missingColumn": "La colonne obligatoire « {{col}} » est absente du fichier.",
        "nameEmpty": "Le nom du produit est vide.",
        "invalidPrice": "Prix invalide (« {{raw}} »).",
        "missingBlueprint": "blueprint_id manquant.",
        "skuEmpty": "Le SKU est vide.",
        "invalidSku": "SKU invalide (« {{sku}} ») — seuls les lettres/chiffres/. _ - sont autorisés.",
        "duplicateSku": "SKU en double dans le fichier (même boutique) : « {{sku}} »."
      }
    },
    "columns": {
      "thumbnail": "Image",
      "name": "Nom",
      "store": "Boutique",
      "storeMore": "+{{count}} autres",
      "category": "Catégorie",
      "sync": "Sync.",
      "created": "Créé",
      "lastModified": "Modifié",
      "actions": ""
    },
    "publish": {
      "success": "« {{name}} » publié sur la boutique",
      "failed": "Échec de la publication"
    },
    "archive": {
      "success": "« {{name}} » archivé"
    },
    "unarchive": {
      "success": "« {{name}} » restauré en brouillon"
    },
    "statusChange": {
      "failed": "Échec de la mise à jour du statut"
    },
    "duplicate": {
      "success": "« {{name}} » dupliqué",
      "failed": "Échec de la duplication"
    },
    "baseProduct": "Modèle de base : {{name}}",
    "delete": {
      "success": "Supprimé « {{name}} »",
      "failed": "Échec de la suppression"
    },
    "lockedHint": "Ce produit privé n'est plus partagé avec votre boutique — vous pouvez le consulter mais pas créer de nouvelles commandes."
  },
  "page": {
    "title": "Catalogue",
    "subtitle": "Parcourez les blueprints et ajoutez-les à votre boutique."
  },
  "filters": {
    "searchPlaceholder": "Rechercher des blueprints…",
    "viewMode": "Mode d'affichage",
    "grid": "Grille",
    "list": "Liste",
    "allCategories": "Toutes les catégories",
    "collections": "Collections",
    "priceRange": "Prix",
    "min": "Min",
    "max": "Max",
    "clearAll": "Tout effacer",
    "totalCount": "{{total}} blueprints"
  },
  "sort": {
    "popular": "Les plus populaires",
    "newest": "Les plus récents",
    "priceAsc": "Prix : croissant",
    "priceDesc": "Prix : décroissant",
    "nameAsc": "Nom : A → Z"
  },
  "category": {
    "apparel": "Vêtements",
    "drinkware": "Boissons",
    "wall-art": "Art mural",
    "accessories": "Accessoires",
    "stationery": "Papeterie"
  },
  "collection": {
    "featured": "À la une",
    "new-arrivals": "Nouveautés",
    "best-sellers": "Best-sellers",
    "seasonal": "Saisonnier"
  },
  "chip": {
    "priceMin": "Min ${{cents}}",
    "priceMax": "Max ${{cents}}"
  },
  "card": {
    "from": "À partir de",
    "view": "Voir",
    "add": "Ajouter à mes produits",
    "swatches": "Couleurs disponibles",
    "tierTooltip": "Prix résolu pour les marchands {{tier}}",
    "added": "Ajouté",
    "addedTooltip": "Vous avez déjà un produit basé sur ce blueprint. Voyez-le dans Mes produits."
  },
  "badge": {
    "new": "Nouveau",
    "outOfStock": "Rupture de stock",
    "featured": "En vedette"
  },
  "featured": {
    "title": "Modèles à la une",
    "subtitle": "Mises en page prêtes à personnaliser"
  },
  "empty": {
    "title": "Aucun blueprint correspondant",
    "body": "Le catalogue est en préparation. Revenez bientôt.",
    "bodyWithFilters": "Aucun blueprint ne correspond aux filtres. Essayez d'en retirer.",
    "reset": "Effacer tous les filtres"
  },
  "errors": {
    "loadFailed": "Impossible de charger le catalogue. Veuillez réessayer.",
    "retry": "Réessayer"
  },
  "detail": {
    "loading": "Chargement du blueprint…",
    "breadcrumb": "Fil d'Ariane",
    "description": "Description",
    "notFound": {
      "title": "Blueprint introuvable",
      "body": "Le blueprint demandé n'est plus disponible.",
      "backToCatalog": "Retour au catalogue"
    },
    "tierPrice": {
      "title": "Tarif par niveau",
      "yourTier": "Votre niveau",
      "dealBadge": "Promo",
      "otherTierTooltip": "Tarif visible uniquement pour votre niveau",
      "noTierHint": "Votre niveau n'est pas encore chargé — connectez-vous."
    },
    "variant": {
      "title": "Variantes",
      "color": "Couleur",
      "size": "Taille",
      "outOfStock": "Rupture de stock",
      "empty": "Aucune variante disponible"
    },
    "printAreas": {
      "title": "Zones d'impression",
      "front": "Devant",
      "back": "Dos",
      "sleeve_left": "Manche gauche",
      "sleeve_right": "Manche droite"
    },
    "print": {
      "title": "Zones d'impression",
      "subtitle": "Cliquez une zone pour voir les dimensions",
      "mockupAlt": "Mockup du vêtement",
      "printZones": "Zones d'impression",
      "embroideryZones": "Zones de broderie",
      "stitches": "points",
      "maxDpi": "Max",
      "maxStitches": "Points maximum"
    },
    "related": {
      "title": "Produits associés"
    },
    "cta": {
      "addToProducts": "Ajouter à mes produits",
      "disabledTooltip": "Ce blueprint ne peut pas être ajouté pour le moment.",
      "added": "Ajouté à Mes produits",
      "addedTooltip": "Vous avez déjà un produit basé sur ce blueprint. Voyez-le dans Mes produits.",
      "viewMine": "Voir dans Mes produits"
    },
    "addons": {
      "title": "Options & accessoires",
      "addonsLabel": "Options",
      "accessoriesLabel": "Accessoires",
      "required": "requis"
    },
    "gallery": {
      "thumbStrip": "Miniatures du mockup",
      "openLightbox": "Ouvrir en plein écran",
      "lightboxTitle": "Mockup en plein écran",
      "lightboxDescription": "Flèches pour naviguer, +/- pour zoomer, ESC pour fermer.",
      "zoomIn": "Zoom avant",
      "zoomOut": "Zoom arrière",
      "zoomReset": "Réinitialiser le zoom",
      "zoomFit": "Ajuster",
      "close": "Fermer",
      "prev": "Image précédente",
      "next": "Image suivante",
      "empty": "Aucun mockup disponible"
    },
    "versionLatest": "{{pinned}} (dernière : {{latest}})",
    "edit": "Modifier",
    "media": "Médias",
    "noImage": "Aucune image",
    "primary": "Principale",
    "general": "Général",
    "blueprint": "Blueprint",
    "category": "Catégorie",
    "blueprintVersion": "Version du blueprint",
    "baseCost": "Coût de base (système → marchand)",
    "createdAt": "Créé le",
    "updatedAt": "Mis à jour le",
    "tags": "Étiquettes",
    "variants": "Variantes",
    "size": "Taille",
    "color": "Couleur",
    "priceOverride": "Prix personnalisé",
    "inventory": "Stock",
    "state": "État",
    "retired": "Retiré",
    "restricted": "Réservé",
    "restrictedTitle": "Réservé à un autre marchand — non commandable. Contactez votre gestionnaire de compte pour le changer.",
    "activeVariant": "Actif",
    "pricingPerStore": "Tarification par boutique",
    "store": "Boutique",
    "sellingPrice": "Prix de vente",
    "seo": "SEO",
    "metaTitle": "Méta-titre",
    "slug": "Slug",
    "metaDescription": "Méta-description",
    "customSku": "SKU personnalisé"
  },
  "wizard": {
    "breadcrumb": "Mes Produits / Créer un produit",
    "pageTitle": "Créer un nouveau produit",
    "draftSaved": "Brouillon enregistré à {{ts}}",
    "unsavedWarning": "Vous avez des modifications non enregistrées. Quitter les supprimera.",
    "placeholder": "Cette étape sera bientôt disponible.",
    "title": {
      "step1": "Sélectionner le produit",
      "step15": "Boutiques",
      "step2": "Variantes & Options",
      "step3": "Ajouter le mockup",
      "step4": "Tarification",
      "step5": "Vérifier & Publier"
    },
    "nav": {
      "back": "Retour",
      "saveDraft": "Enregistrer brouillon",
      "next": "Suivant",
      "finish": "Terminer",
      "saving": "Enregistrement…",
      "saveChanges": "Enregistrer les modifications"
    },
    "step1": {
      "heading": "Choisissez un produit de base à personnaliser",
      "desc": "Sélectionnez le blueprint sur lequel votre produit s'appuie.",
      "search": "Rechercher un blueprint…",
      "filter": "Toutes les catégories",
      "empty": "Aucun blueprint ne correspond à la recherche.",
      "emptyHint": "Essayez un autre mot-clé ou une autre catégorie.",
      "select": "Sélectionner",
      "selected": "Sélectionné",
      "selectedLabel": "Blueprint sélectionné",
      "change": "Modifier"
    },
    "step15": {
      "title": "Choisir les boutiques cibles",
      "desc": "Sélectionnez les boutiques qui recevront ce produit lors de la publication. Vous pourrez modifier plus tard.",
      "allStores": "Tout sélectionner",
      "noneStores": "Tout effacer",
      "targetStores": "{{count}} sur {{total}} sélectionnés",
      "minOneRequired": "Sélectionnez au moins une boutique pour continuer.",
      "noStores": "Aucune boutique connectée.",
      "noStoresHint": "Connectez au moins une boutique avant de créer un produit.",
      "connectStore": "Connecter une boutique",
      "loadFailed": "Impossible de charger les boutiques connectées. Réessayez.",
      "disconnected": "Déconnectée"
    },
    "step2": {
      "heading": "Configurer les variantes et les options",
      "desc": "Choisissez les combinaisons taille/couleur à publier et les options proposées à vos clients.",
      "noBlueprint": "Veuillez sélectionner un blueprint à l'étape 1.",
      "loadFailed": "Impossible de charger les variantes du blueprint.",
      "matrixEmpty": "Ce blueprint n'a pas encore de variantes. Continuez vers Visuels.",
      "selectAll": "Tout sélectionner",
      "clearAll": "Tout effacer",
      "enabledCount": "{{count}} sur {{total}} activées",
      "minOneRequired": "Activez au moins une variante pour continuer.",
      "trackOn": "Activé",
      "trackOff": "Désactivé",
      "overridePlaceholder": "Remplacer ¢",
      "required": "requis",
      "addonsTitle": "Options & accessoires",
      "addonsDesc": "Suppléments facultatifs que vos clients peuvent ajouter au paiement.",
      "addonsLabel": "Options",
      "accessoriesLabel": "Accessoires",
      "giftMessage": "Permettre aux clients d'ajouter un message cadeau au paiement",
      "col": {
        "size": "Taille",
        "color": "Couleur",
        "sku": "SKU",
        "inventory": "Suivre le stock",
        "priceOverride": "Remplacement (¢)",
        "customSku": "SKU personnalisé"
      },
      "embroidery": {
        "title": "Configuration de la broderie",
        "desc": "Type de point, taille du cadre et palette de fils pour les zones brodées.",
        "stitchType": "Type de point",
        "frameSize": "Taille du cadre (mm)",
        "threadColors": "Couleurs de fil",
        "addColor": "+ Ajouter une couleur",
        "closePalette": "Fermer",
        "removeColor": "Cliquer pour retirer",
        "stitch": {
          "flat": "Plat",
          "puff": "Relief (3D)"
        },
        "threadAria": "Fil {{hex}}",
        "color": {
          "black": "Noir",
          "white": "Blanc",
          "red": "Rouge",
          "royalBlue": "Bleu roi",
          "green": "Vert",
          "yellow": "Jaune",
          "purple": "Violet",
          "orange": "Orange",
          "teal": "Sarcelle",
          "magenta": "Magenta",
          "brown": "Marron",
          "silver": "Argent",
          "gold": "Or",
          "pink": "Rose"
        }
      },
      "customSkuDup": "SKU personnalisé en double — il doit être unique dans le produit.",
      "customSkuHint": "Facultatif. Laissez vide pour réutiliser le SKU système lors du rapprochement des commandes.",
      "personalized": "Produit personnalisé — chaque commande nécessite un nouveau visuel",
      "axisUnresolved": "Les options {{axis}} de ce blueprint n'ont pas pu être lues ; une valeur provisoire est utilisée. Les commandes de ces variantes risquent de ne pas être tarifables — demandez à un administrateur de vérifier les options du blueprint."
    },
    "step3": {
      "heading": "Ajouter le mockup",
      "desc": "Téléversez jusqu'à 10 images du produit et choisissez-en une comme image principale.",
      "dropzone": "Cliquez ou glissez des images ici pour les téléverser",
      "maxReached": "Maximum de 10 images atteint",
      "mainBadge": "Principale",
      "remove": "Supprimer l'image",
      "setMain": "Définir comme principale",
      "noBlueprint": "Veuillez sélectionner un blueprint à l'étape 1.",
      "loadFailed": "Impossible de charger les zones d'impression.",
      "noMockup": "Aucun mockup disponible pour l'aperçu.",
      "dropHint": "Glissez & déposez votre visuel ici",
      "dropSubhint": "PNG · JPG · SVG · max 25 Mo",
      "uploadCta": "Téléverser",
      "libraryCta": "Choisir dans la bibliothèque",
      "validatingHint": "Vérification du design…",
      "replace": "Remplacer",
      "bulkUpload": "Téléversement groupé",
      "mockupAlt": "Mockup vêtement avec zones d'impression",
      "summary": {
        "passed": "validés",
        "failed": "échoués",
        "inProgress": "en cours"
      },
      "state": {
        "pending": "En file",
        "uploading": "Téléversement…",
        "validating": "Validation…",
        "passed": "Validé",
        "failed": "Échec"
      },
      "errors": {
        "unsupportedMime": "Seuls les fichiers PNG, JPG ou SVG sont autorisés.",
        "tooLarge": "Fichier trop volumineux. Maximum 25 Mo."
      },
      "libraryLoadFailed": "Impossible de charger votre bibliothèque. Réessayez.",
      "libraryTitle": "Choisir dans la bibliothèque",
      "libraryEmpty": "Votre bibliothèque est vide.",
      "libraryEmptyHint": "Téléversez un fichier via la zone de glisser-déposer ci-dessous — il apparaîtra ici la prochaine fois."
    },
    "step4": {
      "heading": "Définir le prix de vente par boutique",
      "desc": "Le paiement est toujours en USD. Les cellules à marge négative sont surlignées en rouge.",
      "noBlueprint": "Veuillez choisir un modèle à l'étape 1 d'abord.",
      "noStores": "Sélectionnez au moins une boutique à l'étape 1.5 pour définir les prix.",
      "noVariants": "Activez au moins une variante à l'étape 2 pour définir les prix.",
      "col": {
        "variant": "Variante",
        "cost": "Coût de base"
      },
      "priceLabel": "Prix de vente pour {{variant}} sur {{store}}",
      "negativeMargin": "Perte",
      "noCost": "Aucune donnée de coût",
      "summaryTitle": "Résumé tarifaire",
      "summaryDesc": "Aperçu en direct de la marge des cellules tarifées. Le paiement est toujours en USD.",
      "completion": "Cellules tarifées",
      "negativeCells": "Marge négative",
      "minMargin": "Marge min",
      "avgMargin": "Marge moy.",
      "maxMargin": "Marge max",
      "worstCell": "Cellule à perte",
      "usdNote": "Source de vérité : USD. La devise d'affichage est informative uniquement."
    },
    "step5": {
      "heading": "Vérifier et publier votre produit",
      "desc": "Vérifiez chaque étape avant de publier — les tâches de synchronisation s'exécutent immédiatement.",
      "edit": "Modifier",
      "saveDraft": "Enregistrer comme brouillon",
      "saving": "Enregistrement…",
      "publish": "Publier le produit",
      "draftSavedToast": "Brouillon enregistré",
      "publishSuccess": "Produit publié — synchronisation en cours.",
      "publishError": "Impossible de publier le produit.",
      "productInfoTitle": "Informations sur le produit",
      "titleLabel": "Titre",
      "descLabel": "Description",
      "tagsLabel": "Tags",
      "tagPlaceholder": "Ajoutez un tag et appuyez sur Entrée",
      "removeTag": "Retirer {{tag}}",
      "platformFieldsTitle": "Champs par plateforme",
      "noPlatformFields": "Aucune boutique sélectionnée — revenez à l'étape 1.5.",
      "tagsPlaceholder": "Séparé par des virgules",
      "cards": {
        "blueprint": "Modèle",
        "stores": "Publier sur les boutiques",
        "variants": "Variantes",
        "artwork": "Visuel",
        "pricing": "Prix",
        "noBlueprint": "Aucun modèle sélectionné.",
        "noStores": "Aucune boutique sélectionnée.",
        "connected": "Connectée",
        "pending": "En attente",
        "variantsCount": "{{count}} sur {{total}} activées",
        "artworkCount": "{{passed}}/{{total}} zones validées",
        "pricingCount": "{{count}} cellules tarifées",
        "mockup": "Maquette",
        "mainSet": "sélectionnée",
        "mainMissing": "non sélectionnée",
        "mockupEmpty": "Aucune image téléversée",
        "mockupCount": "{{count}} image(s) · image principale {{main}}"
      },
      "publishConfirm": {
        "title": "Publier le produit ?",
        "desc": "Le produit sera créé et des tâches de synchronisation seront envoyées aux boutiques sélectionnées.",
        "product": "Produit",
        "untitled": "(sans titre)",
        "stores": "Synchroniser vers",
        "pricing": "Prix",
        "pricingCount": "{{count}}/{{total}} cellules tarifées",
        "syncWarning": "Les tâches de synchronisation s'exécutent de manière asynchrone — les ID de listing apparaîtront dans Mes Produits.",
        "cancel": "Annuler",
        "publishing": "Publication…",
        "confirm": "Publier"
      },
      "fields": {
        "etsy": {
          "tags": "Tags (max 13)",
          "materials": "Matériaux",
          "whoMade": "Fabricant",
          "whenMade": "Date de fabrication"
        },
        "amazon": {
          "category": "Catégorie",
          "keywords": "Mots-clés",
          "brand": "Marque"
        },
        "tiktok": {
          "weight": "Poids (g)",
          "shippingCategory": "Catégorie d'expédition"
        },
        "shopify": {
          "seoTitle": "Titre SEO",
          "seoDescription": "Description SEO"
        },
        "woo": {
          "taxClass": "Classe fiscale",
          "weight": "Poids (g)"
        },
        "generic": {
          "notes": "Notes"
        }
      }
    },
    "draft": {
      "idle": "Sauvegarde auto prête",
      "saving": "Enregistrement…",
      "savedAt": "Enregistré à {{ts}}",
      "localOnly": "Enregistré localement",
      "resumeTitle": "Reprendre votre brouillon ?",
      "resumeDesc": "Nous avons enregistré votre travail précédent. Vous pouvez le reprendre ou recommencer.",
      "resumeLastSaved": "Dernière sauvegarde {{when}}",
      "resumeConfirm": "Reprendre le brouillon",
      "resumeDiscard": "Recommencer",
      "toastSaved": "Brouillon enregistré sur le serveur",
      "toastNoBlueprint": "Impossible d'enregistrer — choisissez d'abord un blueprint (étape 1).",
      "toastError": "Échec de l'enregistrement serveur — brouillon enregistré localement",
      "resumed": "Brouillon rouvert"
    },
    "breadcrumbEdit": "Mes produits / Modifier le produit",
    "pageTitleEdit": "Modifier le produit"
  },
  "settings": {
    "title": "Paramètres produits",
    "subtitle": "Configurer les paramètres par défaut de vos produits.",
    "back": "Mes produits",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "savedAt": "Enregistré à {{ts}}",
    "pricing": {
      "title": "Tarification par défaut",
      "subtitle": "Appliquée aux nouveaux produits sans prix individuel.",
      "margin": "Marge bénéficiaire par défaut",
      "marginHint": "Utilisée pour calculer le prix de vente des nouveaux produits.",
      "currency": "Devise affichée",
      "currencyHint": "La devise de règlement reste l'USD.",
      "autoSku": "Génération auto du SKU",
      "autoSkuHint": "Crée automatiquement un code SKU pour les nouveaux produits."
    },
    "printMethod": {
      "title": "Méthode d'impression par défaut",
      "subtitle": "Réglages par défaut pour les artworks et l'impression.",
      "method": "Méthode d'impression",
      "minDpi": "DPI minimum",
      "minDpiHint": "Les artworks en dessous de ce seuil seront refusés.",
      "maxFile": "Taille de fichier max",
      "formats": "Formats acceptés",
      "formatsHint": "Cliquez pour activer/désactiver chaque format.",
      "autoResize": "Redimensionnement auto",
      "autoResizeHint": "Redimensionner les artworks à la zone d'impression à l'upload.",
      "options": {
        "dtg": "DTG (impression directe)",
        "dtf": "DTF (transfert film)",
        "sublimation": "Sublimation",
        "embroidery": "Broderie",
        "screen_print": "Sérigraphie"
      }
    },
    "shipping": {
      "title": "Expédition par défaut",
      "subtitle": "Origine + synchronisation par défaut.",
      "origin": "Pays d'origine",
      "leadTime": "Délai de production (jours)",
      "autoSync": "Sync auto vers les boutiques",
      "autoSyncHint": "Les nouveaux produits sont poussés immédiatement vers toutes les boutiques connectées."
    },
    "notifications": {
      "title": "Notifications",
      "subtitle": "Activer/désactiver les alertes par événement produit.",
      "event": "Événement",
      "email": "Email",
      "inApp": "Dans l'application",
      "events": {
        "productPublished": "Produit publié",
        "productSyncFailed": "Échec de synchro produit",
        "productOutOfStock": "Produit en rupture",
        "bulkImportFinished": "Import en masse terminé"
      }
    },
    "aria": {
      "emailEvent": "E-mail {{event}}",
      "inAppEvent": "Dans l'application {{event}}"
    }
  },
  "wizardDrafts": {
    "breadcrumb": "Produits / En cours",
    "title": "Brouillons en cours",
    "hint": "Les brouillons sont sauvegardés automatiquement pendant la création. Supprimés après 30 jours d'inactivité.",
    "empty": "Aucun brouillon.",
    "startNew": "Créer un nouveau produit",
    "untitled": "Sans titre",
    "resume": "Reprendre",
    "confirmDelete": "Supprimer ce brouillon ?",
    "deleted": "Brouillon supprimé",
    "deleteFailed": "Échec de la suppression du brouillon",
    "col": {
      "product": "Produit",
      "blueprint": "Blueprint",
      "progress": "Progression",
      "savedAt": "Enregistré le",
      "expiresAt": "Expire"
    },
    "relative": {
      "expiringSoon": "bientôt expiré",
      "oneDayLeft": "1 jour restant",
      "daysLeft": "{{days}} jours restants"
    }
  },
  "catalog": {
    "cta": {
      "wizardDrafts": "En cours ({{count}})"
    }
  }
}
